import ImageWithBasePath from "@/components/image-with-base-path"
import { Link } from "react-router"


const TeamSection = () => {
  return (
    <>
  {/* Start Team Section */}
  <section className="section team-section-fifteen">
    <div className="container">
      <div
        className="section-header section-header-fifteen wow fadeInUp"
        data-wow-duration="2s"
      >
        <div>
          <div className="section-sub-title">Our Experts</div>
          <h2 className="section-title">
            Expert Coaching &amp; <br /> Facilities{" "}
            <span>Built for Healing</span>
          </h2>
        </div>
        <Link to="#" className="btn btn-white">
          View All Experts
          <span className="icon">
            <i className="isax isax-arrow-right-1" />
          </span>
        </Link>
      </div>
      {/* Start row */}
      <div className="row row-gap-4">
        {/* Start col */}
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div
            className="team-item-fifteen wow fadeInUp"
            data-wow-duration="1s"
          >
            <div className="team-overley">
              <ImageWithBasePath
                src="assets/img/about/team-img-1.jpg"
                alt="team"
                className="img-fluid img-1"
              />
            </div>
            <div className="team-content">
              <h3 className="team-title">
                {" "}
                <Link to="#">Alexandra Whitman</Link>
              </h3>
              <p className="team-description">12 Years Experience</p>
            </div>
            <div className="social-icon">
              <Link to="#" className="icon" aria-label="Facebook">
                <i className="fa-brands fa-facebook" />
              </Link>
              <Link to="#" className="icon" aria-label="Twitter">
                <i className="fa-brands fa-x-twitter" />
              </Link>
              <Link to="#" className="icon" aria-label="Instagram">
                <i className="fa-brands fa-instagram" />
              </Link>
              <Link to="#" className="icon" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin" />
              </Link>
            </div>
          </div>
        </div>
        {/* Start col */}
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div
            className="team-item-fifteen wow fadeInUp"
            data-wow-duration="1s"
          >
            <div className="team-overley">
              <ImageWithBasePath
                src="assets/img/about/team-img-2.jpg"
                alt="team"
                className="img-fluid img-1"
              />
            </div>
            <div className="team-content">
              <h3 className="team-title">
                {" "}
                <Link to="#">Victoria Kensington</Link>
              </h3>
              <p className="team-description">6 Years Experience</p>
            </div>
            <div className="social-icon">
              <Link to="#" className="icon" aria-label="Facebook">
                <i className="fa-brands fa-facebook" />
              </Link>
              <Link to="#" className="icon" aria-label="Twitter">
                <i className="fa-brands fa-x-twitter" />
              </Link>
              <Link to="#" className="icon" aria-label="Instagram">
                <i className="fa-brands fa-instagram" />
              </Link>
              <Link to="#" className="icon" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin" />
              </Link>
            </div>
          </div>
        </div>
        {/* Start col */}
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div
            className="team-item-fifteen wow fadeInUp"
            data-wow-duration="1s"
          >
            <div className="team-overley">
              <ImageWithBasePath
                src="assets/img/about/team-img-3.jpg"
                alt="team"
                className="img-fluid img-1"
              />
            </div>
            <div className="team-content">
              <h3 className="team-title">
                {" "}
                <Link to="#">Kennedy Lawson</Link>
              </h3>
              <p className="team-description">8 Years Experience</p>
            </div>
            <div className="social-icon">
              <Link to="#" className="icon" aria-label="Facebook">
                <i className="fa-brands fa-facebook" />
              </Link>
              <Link to="#" className="icon" aria-label="Twitter">
                <i className="fa-brands fa-x-twitter" />
              </Link>
              <Link to="#" className="icon" aria-label="Instagram">
                <i className="fa-brands fa-instagram" />
              </Link>
              <Link to="#" className="icon" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin" />
              </Link>
            </div>
          </div>
        </div>
        {/* Start col */}
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div
            className="team-item-fifteen wow fadeInUp"
            data-wow-duration="1s"
          >
            <div className="team-overley">
              <ImageWithBasePath
                src="assets/img/about/team-img-4.jpg"
                alt="team"
                className="img-fluid img-1"
              />
            </div>
            <div className="team-content">
              <h3 className="team-title">
                {" "}
                <Link to="#">Brooklyn Hayes</Link>
              </h3>
              <p className="team-description">9 Years Experience</p>
            </div>
            <div className="social-icon">
              <Link to="#" className="icon" aria-label="Facebook">
                <i className="fa-brands fa-facebook" />
              </Link>
              <Link to="#" className="icon" aria-label="Twitter">
                <i className="fa-brands fa-x-twitter" />
              </Link>
              <Link to="#" className="icon" aria-label="Instagram">
                <i className="fa-brands fa-instagram" />
              </Link>
              <Link to="#" className="icon" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* End row */}
    </div>
    <ImageWithBasePath
      src="assets/img/bg/line-bg.png"
      alt="line"
      className="img-fluid line-img"
    />
    <ImageWithBasePath
      src="assets/img/bg/about-img-two.png"
      alt="about"
      className="img-fluid element-1"
    />
  </section>
  {/* End Team Section */}
</>

  )
}

export default TeamSection